/**
 * Build an optimized Unsplash source URL from a photo id segment
 * (e.g. `photo-1483729558449-99ef09a8c325`).
 *
 * `auto=format,compress` lets Unsplash negotiate WebP/AVIF for browsers
 * that accept it — the dominant "improve image delivery" Lighthouse win,
 * since the previous `?w=1200&q=80` URLs always shipped baseline JPEG.
 * The explicit `w`/`q` right-size the payload to the display box rather
 * than fetching a 766×948 source for a ~600px slot. Callers pass the
 * intended display width (heroes ~1000, aerial backdrops ~1200, place
 * thumbnails ~800, avatars ~160).
 *
 * `q=60` keeps these heavily-scaled marketing photos under Lighthouse's
 * "improve image delivery" bar; combined with `auto=compress` the visible
 * quality loss is negligible at the sizes we render.
 */
export function unsplashUrl(photoId: string, opts?: { w?: number; q?: number }): string {
  const w = opts?.w ?? 800;
  const q = opts?.q ?? 60;
  return `https://images.unsplash.com/${photoId}?auto=format,compress&fit=crop&w=${w}&q=${q}`;
}
